import React from "react";

export function FooterYoutube() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_1849_693)">
        <path d="M10.457 9.63818V14.0191L14.4951 11.8477L10.457 9.63818Z" fill="#698ACD" />
        <path d="M17.981 0H6C2.70476 0 0 2.70476 0 6.01905V18C0 21.2952 2.70476 24 6 24H17.981C21.2952 24 24 21.2952 24 17.981V6.01905C24 2.70476 21.2952 0 17.981 0ZM19.4286 12.5905C19.4286 13.8476 19.3143 15.1238 19.3143 15.1238C19.3143 15.1238 19.181 16.1905 18.7429 16.6667C18.1714 17.2952 17.5429 17.2952 17.2571 17.3333C15.1619 17.4857 12.019 17.5048 12.019 17.5048C12.019 17.5048 8.11429 17.4476 6.91429 17.3333C6.59048 17.2762 5.82857 17.2952 5.25714 16.6667C4.8 16.1905 4.68571 15.1238 4.68571 15.1238C4.68571 15.1238 4.57143 13.8476 4.57143 12.5905V11.4095C4.57143 10.1524 4.68571 8.87619 4.68571 8.87619C4.68571 8.87619 4.81905 7.80952 5.25714 7.33333C5.82857 6.70476 6.45714 6.68571 6.74286 6.64762C8.85714 6.49524 12 6.47619 12 6.47619C12 6.47619 15.1429 6.49524 17.2381 6.64762C17.5238 6.68571 18.1714 6.70476 18.7429 7.31429C19.2 7.79048 19.3143 8.87619 19.3143 8.87619C19.3143 8.87619 19.4286 10.1524 19.4286 11.4095V12.5905Z" fill="#698ACD" />
      </g>
      <defs>
        <clipPath id="clip0_1849_693">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
